import { render, staticRenderFns } from "./MyCollectionTask.vue?vue&type=template&id=23527e78&scoped=true"
import script from "./MyCollectionTask.vue?vue&type=script&lang=js"
export * from "./MyCollectionTask.vue?vue&type=script&lang=js"
import style0 from "./MyCollectionTask.vue?vue&type=style&index=0&id=23527e78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23527e78",
  null
  
)

export default component.exports